var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGanderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0491 9.03666L18.5858 5.5H14V3.5H22V11.5H20V6.91421L16.4633 10.4509C17.4274 11.7127 18 13.2895 18 15C18 19.1421 14.6421 22.5 10.5 22.5C6.35786 22.5 3 19.1421 3 15C3 10.8579 6.35786 7.5 10.5 7.5C12.2105 7.5 13.7873 8.07264 15.0491 9.03666ZM10.5 20.5C13.5376 20.5 16 18.0376 16 15C16 11.9624 13.5376 9.5 10.5 9.5C7.46243 9.5 5 11.9624 5 15C5 18.0376 7.46243 20.5 10.5 20.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanderIcon);
export default __webpack_public_path__ + "static/media/gander-icon.24ef82b953595ca3230371e57d6411ed.svg";
export { ForwardRef as ReactComponent };